import "@astryxdesign/core/reset.css";
import "@astryxdesign/core/astryx.css";
import { ToastViewport } from "@astryxdesign/core/Toast";
import { Theme } from "@astryxdesign/core/theme";
import { toolsTheme } from "@karrtopelka/tools-kit/theme";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App.js";

const root = document.getElementById("root");
if (!root) throw new Error("missing #root");

createRoot(root).render(
  <StrictMode>
    <Theme theme={toolsTheme} mode="dark">
      <ToastViewport position="bottomEnd">
        <App />
      </ToastViewport>
    </Theme>
  </StrictMode>,
);
